import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MobileHeader = styled.div`
    display: none;
    ${media.mobileDevice`
    width: auto;
    height: 74px;
    display: flex;
    justify-content: space-between;
    margin-top: -70px;
        background: #140F4B;
    `}
`;

export const InventoryContainer = styled.div`

    @media screen and (min-width: 660px) and (max-width: 1024px) and (orientation: landscape) {
        /* iPad Chrome keyboard fix: use --vh CSS variable instead of 100vh/50vh 
           to account for dynamic keyboard visibility and address bar changes */
        height: ${({ bannerHeight }) => (bannerHeight ? '50vh' : '60vh')};
        overflow-x: auto;
    }

    @media screen and (min-device-width: 410px) and (max-device-width: 420px) and (orientation: landscape) {
        height: '50vh';
        overflow-x: auto;
    }

    ${media.mobileDevice`
        position:fixed;
        width:100%;
    `}
`;

export const Title = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 24px;
    color: #140f4b;
    letter-spacing: 0px;
    opacity: 1;
    text-align: center;
    ${media.smalDevice`    
    font-family: 'AvenirNextWorld Demi';
    color: #FFFFFF;
    font-size: 22px;
    text-align: left;
    letter-spacing: 0px;
    margin: auto;
   // margin-left :18%;
    justify-content: center;
    padding-right: 30px;
    `}
`;

export const MainSubContainer = styled.div`
    background: #f5f5f5 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 100%;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    padding: 0;

    ${media.mobileDevice`
        //Horizontal scroll remove
        width: 100%;
        //  curve issue
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 0 15px;
        height: calc(100vh - 280px);
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
        padding-bottom: 30px;
    `};
`;
